
import { Component, Vue, Prop } from 'vue-property-decorator';
import { store, action } from '@/common/store';
import { isDebug } from '@/common/api';
import PosterDialog from './PosterDialog.vue';
import logger from '@plat-components/utils2/_esm5/logger'
import login from '@common/login';

@Component({
  name: 'PosterModule',
  components: { PosterDialog },
})
export default class PosterModule extends Vue {
  posterVisible1 = false;
  posterVisible2 = false;
  posterVisible3 = false;
  posterVisible4 = false;
  isLight1 = false;
  isLight2 = false;
  isLight3 = false;
  isLight4 = false;
  posterName = ''

  get getUserInfo() {
    return store.userInfo || false;
  }

  async mounted() {
    await action.getUserInfo();
    if (isDebug) {
      localStorage.removeItem(`poster_1_${this.getUserInfo?.mid}`);
      localStorage.removeItem(`poster_2_${this.getUserInfo?.mid}`);
      localStorage.removeItem(`poster_3_${this.getUserInfo?.mid}`);
      localStorage.removeItem(`poster_4_${this.getUserInfo?.mid}`);
      localStorage.removeItem(`posterBase64_1_${this.getUserInfo?.mid}`);
      localStorage.removeItem(`posterBase64_2_${this.getUserInfo?.mid}`);
      localStorage.removeItem(`posterBase64_3_${this.getUserInfo?.mid}`);
      localStorage.removeItem(`posterBase64_4_${this.getUserInfo?.mid}`);
      localStorage.removeItem(`poster_btn1`);
      localStorage.removeItem(`poster_btn2`);
      localStorage.removeItem(`poster_btn3`);
      localStorage.removeItem(`poster_btn4`);
    }
    this.isLight1 = localStorage.getItem('poster_btn1') === 'true';
    this.isLight2 = localStorage.getItem('poster_btn2') === 'true';
    this.isLight3 = localStorage.getItem('poster_btn3') === 'true';
    this.isLight4 = localStorage.getItem('poster_btn4') === 'true';
    this.$nextTick(() => {
      // 初始化海报
      this.initPoster();
      // 获取图片按钮并注册点击事件
      const posterbtn1 = document.getElementById('MW6gowR9n20') as HTMLElement;
      const posterbtn2 = document.getElementById('Mi3Mow8BTUS') as HTMLElement;
      const posterbtn3 = document.getElementById('MCJkHt6dTDi') as HTMLElement;
      const posterbtn4 = document.getElementById('M3DVxo4k79k') as HTMLElement;
      const posterbtn5 = document.getElementById('MZR2Uv5hHj7') as HTMLElement;
      const posterbtn6 = document.getElementById('MWKq7HzzdnD') as HTMLElement;
      const posterbtn7 = document.getElementById('MYXl7U7zXdG') as HTMLElement;
      const posterbtn8 = document.getElementById('MhPHYPzeVTy') as HTMLElement;
      // 第1组
      if (posterbtn1) {
        // 弹窗按钮出现
        logger('button_show_MW6gowR9n20')

        posterbtn1.onclick = () => {
          // 点击
          logger('button_click_MW6gowR9n20')
          
          if (this.isLogin()) {
            return
          }

          this.handlePosterShow(1, 'MW6gowR9n20');
          this.isLight1 = true;
          localStorage.setItem(`poster_btn1`, 'true');
        };
      }
      if (posterbtn2) {
        // 弹窗按钮出现
        logger('button_show_Mi3Mow8BTUS')

        posterbtn2.onclick = () => {
          // 点击
          logger('button_click_Mi3Mow8BTUS')

          if (this.isLogin()) {
            return
          }

          this.handlePosterShow(1, 'Mi3Mow8BTUS');
          this.isLight1 = true;
          localStorage.setItem(`poster_btn1`, 'true');
        };
      }
      // 第2组
      if (posterbtn3) {
        // 弹窗按钮出现
        logger('button_show_MCJkHt6dTDi')

        posterbtn3.onclick = () => {
          // 点击
          logger('button_click_MCJkHt6dTDi')

          if (this.isLogin()) {
            return
          }

          this.handlePosterShow(2, 'MCJkHt6dTDi');
          this.isLight2 = true;
          localStorage.setItem(`poster_btn2`, 'true');
        };
      }
      if (posterbtn4) {
        // 弹窗按钮出现
        logger('button_show_M3DVxo4k79k')

        posterbtn4.onclick = () => {
          // 点击
          logger('button_click_M3DVxo4k79k')

          if (this.isLogin()) {
            return
          }

          this.handlePosterShow(2, 'M3DVxo4k79k');
          this.isLight2 = true;
          localStorage.setItem(`poster_btn2`, 'true');
        };
      }
      // 第3组
      if (posterbtn5) {
        // 弹窗按钮出现
        logger('button_show_MZR2Uv5hHj7')

        posterbtn5.onclick = () => {
          // 点击
          logger('button_click_MZR2Uv5hHj7')

          if (this.isLogin()) {
            return
          }

          this.handlePosterShow(3, 'MZR2Uv5hHj7');
          this.isLight3 = true;
          localStorage.setItem(`poster_btn3`, 'true');
        };
      }
      if (posterbtn6) {
        // 弹窗按钮出现
        logger('button_show_MWKq7HzzdnD')

        posterbtn6.onclick = () => {
          // 点击
          logger('button_click_MWKq7HzzdnD')

          if (this.isLogin()) {
            return
          }

          this.handlePosterShow(3, 'MWKq7HzzdnD');
          this.isLight3 = true;
          localStorage.setItem(`poster_btn3`, 'true');
        };
      }
      // 第4组
      if (posterbtn7) {
        // 弹窗按钮出现
        logger('button_show_MYXl7U7zXdG')

        posterbtn7.onclick = () => {
          // 点击
          logger('button_click_MYXl7U7zXdG')

          if (this.isLogin()) {
            return
          }

          this.handlePosterShow(4, 'MYXl7U7zXdG');
          this.isLight4 = true;
          localStorage.setItem(`poster_btn4`, 'true');
        };
      }
      if (posterbtn8) {
        // 弹窗按钮出现
        logger('button_show_MhPHYPzeVTy')

        posterbtn8.onclick = () => {
          // 点击
          logger('button_click_MhPHYPzeVTy')

          if (this.isLogin()) {
            return
          }

          this.handlePosterShow(4, 'MhPHYPzeVTy');
          this.isLight4 = true;
          localStorage.setItem(`poster_btn4`, 'true');
        };
      }
    });
  }

  isLogin(){
    if (!this.getUserInfo) {
      login();
      return true
    }
  }

  // 初始化海报
  initPoster() {
    this.getPosterInit(1);
    this.getPosterInit(2);
    this.getPosterInit(3);
    this.getPosterInit(4);
  }

  getPosterInit(num: number) {
    const posterComponent1 = this.$refs.posterDialog1 as any;
    const posterComponent2 = this.$refs.posterDialog2 as any;
    const posterComponent3 = this.$refs.posterDialog3 as any;
    const posterComponent4 = this.$refs.posterDialog4 as any;
    switch (num) {
      case 1:
        posterComponent1?.posterShow(num);
        break;
      case 2:
        posterComponent2?.posterShow(num);
        break;
      case 3:
        posterComponent3?.posterShow(num);
        break;
      case 4:
        posterComponent4?.posterShow(num);
        break;

      default:
        break;
    }
  }

  // 关闭弹窗
  onClose() {
    this.posterVisible1 = false;
    this.posterVisible2 = false;
    this.posterVisible3 = false;
    this.posterVisible4 = false;
  }

  // 海报弹窗
  handlePosterShow(num: number, name: string) {
    this.posterName = name
    switch (num) {
      case 1:
        logger(`poster_show_${name}`)
        this.posterVisible1 = true;
        break;
      case 2:
        logger(`poster_show_${name}`)
        this.posterVisible2 = true;
        break;
      case 3:
        logger(`poster_show_${name}`)
        this.posterVisible3 = true;
        break;
      case 4:
        logger(`poster_show_${name}`)
        this.posterVisible4 = true;
        break;

      default:
        break;
    }
  }
}
